// Tab functionality
const section = document.querySelector('.tabs');

const tabs = section.querySelectorAll('.tabs-nav-item');
const panels = section.querySelectorAll('.tabs-panel');

function activateTab(index) {
  tabs.forEach(function (t) {
    t.classList.remove('tabs-nav-item--active');
    t.setAttribute('aria-selected', 'false');
  });
  panels.forEach(function (p) {
    p.classList.remove('tabs-panel--active');
    p.setAttribute('hidden', '');
  });
  const tab = tabs[index];
  if (tab) {
    tab.classList.add('tabs-nav-item--active');
    tab.setAttribute('aria-selected', 'true');
    const panelId = tab.getAttribute('aria-controls');
    const panel = document.getElementById(panelId);
    if (panel) {
      panel.classList.add('tabs-panel--active');
      panel.removeAttribute('hidden');
    }
  }
}

// Activate tab from URL hash (e.g. #tab-2)
const hash = window.location.hash;
if (hash) {
  const match = hash.match(/^#tab-(\d+)$/);
  if (match) {
    const tabIndex = parseInt(match[1], 10) - 1;
    if (tabIndex >= 0 && tabIndex < tabs.length) {
      activateTab(tabIndex);
      section.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

// Tab click event listeners
tabs.forEach(function (tab, i) {
  tab.addEventListener('click', function () {
    activateTab(i);
  });
});

// Footer link click event listeners to activate corresponding tab and scroll to section
document.querySelectorAll('#footer-toggle-1 a, #HeaderMenu-MenuList-1 a').forEach((link) => {
  link.addEventListener('click', (e) => {
    const href = link.getAttribute('href');
    const hashMatch = href.match(/#tab-(\d+)$/);
    if (hashMatch) {
      e.preventDefault();
      const tabIndex = parseInt(hashMatch[1], 10) - 1;
      if (tabIndex >= 0 && tabIndex < tabs.length) {
        activateTab(tabIndex);
        history.replaceState(null, '', '#tab-' + (tabIndex + 1));
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  });
});

// Smooth toggle animation for <details> elements
section.querySelectorAll('.item-toggle').forEach(function (details) {
  const summary = details.querySelector('.item-trigger');
  const content = details.querySelector('.item-content');

  content.addEventListener('transitionend', function () {
    if (details.classList.contains('is-open')) {
      content.style.height = 'auto';
    } else {
      content.style.height = '';
    }
  });

  summary.addEventListener('click', function (e) {
    if (details.classList.contains('is-open')) {
      // Close: set explicit height, then transition to 0
      content.style.height = content.scrollHeight + 'px';
      requestAnimationFrame(function () {
        content.style.height = '0px';
      });
      details.classList.remove('is-open');
    } else {
      // Open: transition from 0 to scrollHeight
      details.classList.add('is-open');
      content.style.height = '0px';
      requestAnimationFrame(function () {
        content.style.height = content.scrollHeight + 'px';
      });
    }
  });
});
